import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "dropArea", "fileName", "placeholder", "fileRow", "destroy"]

  dragover(event) {
    event.preventDefault()
    this.dropAreaTarget.classList.add("border-[#5B8BF5]", "bg-blue-50/50")
  }

  dragleave() {
    this.dropAreaTarget.classList.remove("border-[#5B8BF5]", "bg-blue-50/50")
  }

  drop(event) {
    event.preventDefault()
    this.dropAreaTarget.classList.remove("border-[#5B8BF5]", "bg-blue-50/50")

    const files = event.dataTransfer.files
    if (files.length > 0) {
      this.inputTarget.files = files
      this.showFile(files[0].name)
    }
  }

  select() {
    this.inputTarget.click()
  }

  changed() {
    const files = this.inputTarget.files
    if (files.length > 0) {
      this.showFile(files[0].name)
    }
  }

  removePersisted() {
    if (this.hasDestroyTarget) {
      this.destroyTarget.value = "true"
    }
    this.remove()
  }

  remove() {
    this.inputTarget.value = ""
    if (this.hasDropAreaTarget) {
      this.dropAreaTarget.style.display = ""
      if (this.hasPlaceholderTarget) {
        this.placeholderTarget.classList.remove("hidden")
      }
    }
    if (this.hasFileRowTarget) {
      this.fileRowTarget.style.display = "none"
    }
  }

  showFile(name) {
    if (this.hasFileNameTarget) {
      this.fileNameTarget.textContent = name
    }
    if (this.hasDropAreaTarget) {
      this.dropAreaTarget.style.display = "none"
    }
    if (this.hasFileRowTarget) {
      this.fileRowTarget.style.display = "flex"
    }
    if (this.hasDestroyTarget) {
      this.destroyTarget.value = "false"
    }
  }
}
